<div class="modal-header">
  <div class="header-content">
    <h2 mat-dialog-title class="clean-title">{{ dialogTitle }}</h2>
    <span class="ref-badge"><i class="fa-solid fa-hashtag"></i> {{ data.rowData['v_ladings.alternate_reference'] || data.lading_uuid }}</span>
  </div>
</div>

<mat-dialog-content class="mat-typography custom-scroll">
  
  <div class="action-card">
    <div class="action-card-header">
      <i class="fa-solid fa-user-plus text-primary"></i> 
      <span>Assign a Technician</span>
    </div>
    <div class="assign-section">
      <mat-form-field appearance="outline" class="tech-select flex-1">
        <mat-label>Search by name, email, or provider...</mat-label>
        <mat-select [(ngModel)]="selectedTechUuid" [disabled]="loadingTechs || saving">
          
          <mat-option>
            <ngx-mat-select-search 
              [formControl]="techFilterCtrl" 
              placeholderLabel="Type to filter..." 
              noEntriesFoundLabel="No matching technicians">
            </ngx-mat-select-search>
          </mat-option>
  
          <mat-option *ngFor="let t of filteredTechs" [value]="t.technician_uuid" class="custom-option">
            <span class="option-name">{{ t.first_name }} {{ t.last_name }}</span>
            <span class="option-provider" *ngIf="t.provider_name">{{ t.provider_name }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <button mat-flat-button color="primary" class="btn-tall shadow-sm" 
              [disabled]="!selectedTechUuid || saving" 
              (click)="assignSelected()">
        {{ saving ? 'Assigning...' : 'Assign' }}
      </button>
    </div>
  </div>

  <div class="assigned-list" *ngIf="assignments.length > 0">
    <h3 class="section-header">Currently Assigned ({{ assignments.length }})</h3>
    
    <mat-card *ngFor="let a of assignments" class="tech-card shadow-sm border-slate">
      <mat-card-content class="tech-card-content">
        
        <div class="tech-info">
          <div class="tech-name">
            <strong>{{ name(a) }}</strong>
            <span class="provider-pill" *ngIf="a.provider_name">{{ a.provider_name }}</span>
          </div>
          <div class="tech-contact">
            <span *ngIf="a.phone"><i class="fa-solid fa-phone"></i> {{ a.phone }}</span>
            <span *ngIf="a.email"><i class="fa-solid fa-envelope"></i> {{ a.email }}</span>
          </div>
          <div class="tech-ts">
            <i class="fa-regular fa-clock"></i> Assigned: {{ ts(a.assigned_at) }}
          </div>
        </div>

        <div class="tech-actions">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="status-select">
            <mat-select [value]="a.status" (selectionChange)="updateStatus(a, $event.value)" [disabled]="saving">
              <mat-option value="pending">Pending</mat-option>
              <mat-option value="accepted">Accepted</mat-option>
              <mat-option value="en_route">En Route</mat-option>
              <mat-option value="on_site">On Site</mat-option>
              <mat-option value="completed">Completed</mat-option>
              <mat-option value="declined">Declined</mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button class="btn-danger-light" (click)="unassign(a)" [disabled]="saving" matTooltip="Remove Technician">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>
        
      </mat-card-content>
    </mat-card>
  </div>

  <div *ngIf="!loadingAssignments && assignments.length === 0" class="empty-state">
    <div class="empty-icon-wrapper">
      <i class="fa-duotone fa-users-slash"></i>
    </div>
    <h4>No technicians assigned</h4>
    <p>Select a technician from the dropdown above to add them to this work order.</p>
  </div>

  <hr class="divider" />

  <mat-accordion class="modern-accordion">
    <mat-expansion-panel class="mat-elevation-z0 border-panel">
      <mat-expansion-panel-header class="modern-panel-header">
        <mat-panel-title>
          <i class="fa-solid fa-sparkles text-accent"></i>
          Can't find them? Create a new technician
        </mat-panel-title>
      </mat-expansion-panel-header>

      <form [formGroup]="addForm" (ngSubmit)="createAndAssign()" class="add-tech-form">
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="first_name" required>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="last_name" required>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Phone</mat-label>
            <input matInput formControlName="phone">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email">
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input matInput formControlName="city">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Region</mat-label>
            <input matInput formControlName="region">
          </mat-form-field>
        </div>
        <div class="provider-row">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Provider</mat-label>
            <mat-select formControlName="technician_provider_uuid">
              <mat-option [value]="null">— None —</mat-option>
              <mat-option *ngFor="let p of providers" [value]="p.technician_provider_uuid">{{ p.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-stroked-button type="button" class="btn-tall" (click)="toggleProviderForm()">
            {{ showProviderForm ? 'Cancel' : '+ New' }}
          </button>
        </div>
        <div class="new-provider-row" *ngIf="showProviderForm">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>New Provider Name</mat-label>
            <input matInput [(ngModel)]="newProviderName" [ngModelOptions]="{ standalone: true }">
          </mat-form-field>
          <button mat-flat-button color="accent" type="button" class="btn-tall shadow-sm" 
                  [disabled]="savingProvider || !newProviderName.trim()" (click)="createProvider()">
            {{ savingProvider ? '...' : 'Save' }}
          </button>
        </div>
        <div class="form-actions mt-4">
          <button mat-button type="button" (click)="addForm.reset()" class="text-slate-500 hover-bg-slate">Clear</button>
          <button mat-flat-button color="accent" type="submit" class="shadow-sm" [disabled]="addForm.invalid || saving">
            {{ saving ? 'Creating...' : 'Create & Assign' }}
          </button>
        </div>
      </form>
    </mat-expansion-panel>
  </mat-accordion>

</mat-dialog-content>

<div class="modal-footer">
  <button mat-button mat-dialog-close (click)="close()" class="text-slate-500 hover-bg-slate">Close</button>
</div>